import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="site-builder--dropdown"
export default class extends Controller {
  static targets = ["options", "action"];
  static values = {
    container: String
  }

  connect() {
    if (this.hasContainerValue) {
      this.container = this.element.closest(this.containerValue)
    }
  }

  toggle() {
    this.optionsTarget.classList.toggle('visible');
  }

  show() {
    this.optionsTarget.classList.add('visible');
    if (this.hasContainerValue) {
      /*
          Align the dropdown to top, if its hiding in the scroll height of container
       */
      this.#adjustAlignment()
    }
  }

  hide = () => {
    this.optionsTarget.classList.remove('visible', 'top');
  }

  #adjustAlignment() {
    const {bottom: dropdownBottom} = this.optionsTarget.getBoundingClientRect();
    const {bottom: ContainerBottom} = this.container.getBoundingClientRect();
    if (dropdownBottom > ContainerBottom) {
      this.optionsTarget.classList.add('top');
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }
}
